require('../fonts/mtiFontTrackingCode')
import svg4everybody from 'svg4everybody'

// Start SVG polyfill
svg4everybody()
